export default {
  name: 'dialogForm',

  props: {
    editingForm: Object,
    customComponents: Object,
    items: Array,
    jsonLogicContext: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    // /////////////////////////////////////////////////////////////////////////////////////////////////
    // Gestione Dialog con il form
    // /////////////////////////////////////////////////////////////////////////////////////////////////
    closeFormDialog () {
      if (this.editingForm?.fnReject && typeof this.editingForm.fnReject === 'function') {
        this.editingForm.fnReject()
      }
    },

    submitFormDialog (model) {
      if (this.editingForm?.fnResolve && typeof this.editingForm.fnResolve === 'function') {
        this.editingForm.fnResolve(model)
      }
    }
    // /////////////////////////////////////////////////////////////////////////////////////////////////
  }
}
